// 



import React, { useState } from 'react';

interface ImageData {
    url: string;
    description: string;
    date?: string; // Optional: add a date field if you want to show date like in the screenshot
}

interface ImageCarouselProps {
    images: ImageData[];
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ images }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const cardsPerView = {
        mobile: 1,
        tablet: 2,
        desktop: 4
    };

    const nextSlide = () => {
        const maxIndex = Math.max(0, images.length - cardsPerView.desktop);
        setCurrentIndex((prevIndex) =>
            prevIndex >= maxIndex ? 0 : prevIndex + 1
        );
    };

    const prevSlide = () => {
        const maxIndex = Math.max(0, images.length - cardsPerView.desktop);
        setCurrentIndex((prevIndex) =>
            prevIndex <= 0 ? maxIndex : prevIndex - 1
        );
    };

    if (!images || images.length === 0) {
        return (
            <div className="flex items-center justify-center p-8 text-gray-500">
                No images to display
            </div>
        );
    }

    // Sample data for demonstration
    const sampleImages = images.length > 0 ? images : [
        {
            url: "https://picsum.photos/400/300?random=1",
            description: "The Ocean Cleanup and AWS Join Forces to Accelerate Ocean Plastic Removal using AI",
            date: "15 July"
        },
        {
            url: "https://picsum.photos/400/300?random=2",
            description: "The Ocean Cleanup launches 30 cities program to cut ocean plastic pollution from rivers by one third by 2030",
            date: "12 June"
        },
        {
            url: "https://picsum.photos/400/300?random=3",
            description: "The Ocean Cleanup Pacific Data Expedition 2025",
            date: "1 May"
        },
        {
            url: "https://picsum.photos/400/300?random=4",
            description: "Improved Cisadane Interceptor to become fully operational",
            date: "16 May"
        }
    ];

    return (
        <div className=" " style={{marginBottom:"20px"}}>
            {/* White Card Wrapper */}
            <div className="bg-white rounded-2xl shadow-sm mx-4 p-8">
                <span className='card-label fw-bold fs-3 mb-1'>Latest events and news</span>
                {/* <h2 className="text-xl font-bold text-gray-900 mb-6">Latest events and news</h2> */}
                {/* Main Carousel Container */}
                <div className="relative overflow-hidden">
                    {/* Cards Container */}


                    {/* <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                        <button style={{
                            backgroundColor: '#2563EB',
                            color: '#ffffff',
                            padding: '0.5rem 1.5rem',
                            borderRadius: '9999px',
                            fontWeight: '500',
                            fontSize: '0.875rem',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            boxShadow: '0 0 0 rgba(0, 0, 0, 0)',
                        }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#1D4ED8';
                                e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
                                e.currentTarget.style.transform = 'scale(1.05)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#2563EB';
                                e.currentTarget.style.boxShadow = '0 0 0 rgba(0, 0, 0, 0)';
                                e.currentTarget.style.transform = 'scale(1)';
                            }}
                        >
                            Show All
                        </button>
                    </div> */}
                    <div
                        className="flex transition-transform duration-500 ease-in-out"
                        style={{
                            transform: `translateX(-${currentIndex * (100 / cardsPerView.desktop)}%)`,
                        }}
                    >
                        {sampleImages.map((image, index) => (
                            <div
                                key={index}
                                className="w-full md:w-1/2 lg:w-1/4 flex-shrink-0 px-3 my-4"
                            >
                                {/* CARD */}
                                <div className="relative rounded-2xl overflow-hidden shadow-md group h-[400px] flex flex-col justify-end bg-black">
                                    {/* Image */}
                                    <img
                                        src={image.url}
                                        alt={`Image ${index + 1}`}
                                        className="absolute inset-0 w-full h-full object-cover z-0 group-hover:scale-105 transition duration-300"
                                        onError={(e) => {
                                            const target = e.target as HTMLImageElement;
                                            target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjNmNGY2Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5YTNhZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkltYWdlIG5vdCBmb3VuZDwvdGV4dD48L3N2Zz4=';
                                        }}
                                    />
                                    {/* Gradient dark overlay */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent z-10" />
                                    {/* Date Top Left (optional) */}
                                    {image.date && (
                                        <div className="absolute left-6 top-6 z-20 text-white font-semibold text-xs bg-black/60 px-2 py-[2px] rounded">
                                            {image.date}
                                        </div>
                                    )}
                                    {/* Card Content */}
                                    <div className="relative z-20 p-6 flex flex-col mt-auto h-[52%] justify-end">
                                        <p className="text-white text-lg font-semibold leading-tight drop-shadow mb-2">
                                            {image.description}
                                        </p>
                                        {/* Divider Line */}
                                        <hr className="border-t border-gray-400/40 my-2 w-full" />
                                        {/* Button + Label row */}
                                        <div className="flex items-center mt-2">
                                            <button
                                                className="w-9 h-9 flex items-center justify-center bg-[#00d3ef] hover:bg-blue-600 text-white rounded-full shadow-lg mr-3 transition"
                                                aria-label="More"
                                            >
                                                <span className="text-2xl font-bold">→</span>
                                            </button>
                                            <span className="text-white font-medium text-sm opacity-80 underline cursor-pointer hover:opacity-100 transition">
                                                Read the update
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Navigation Arrows */}
                {sampleImages.length > cardsPerView.desktop && (
                    <>
                        <button
                            onClick={prevSlide}
                            className="absolute left-8 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-95 hover:bg-opacity-100 rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 z-20 border border-gray-200"
                            aria-label="Previous images"
                        >
                            <div className="w-6 h-6 flex items-center justify-center">
                                <span className="text-gray-700 text-2xl font-bold">‹</span>
                            </div>
                        </button>

                        <button
                            onClick={nextSlide}
                            className="absolute right-8 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-95 hover:bg-opacity-100 rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 z-20 border border-gray-200"
                            aria-label="Next images"
                        >
                            <div className="w-6 h-6 flex items-center justify-center">
                                <span className="text-gray-700 text-2xl font-bold">›</span>
                            </div>
                        </button>
                    </>
                )}

                {/* Dots Indicator */}
                {sampleImages.length > cardsPerView.desktop && (
                    <div className="flex justify-center mt-8 space-x-3">
                        {Array.from({ length: Math.ceil(sampleImages.length / cardsPerView.desktop) }).map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentIndex(index)}
                                className={`w-4 h-4 rounded-full transition-all duration-300 ${Math.floor(currentIndex / cardsPerView.desktop) === index
                                    ? 'bg-blue-600 scale-125 shadow-lg'
                                    : 'bg-gray-300 hover:bg-gray-400 hover:scale-110'
                                    }`}
                                aria-label={`Go to slide set ${index + 1}`}
                            />
                        ))}
                    </div>
                )}

                {/* Slide Counter */}
                {sampleImages.length > cardsPerView.desktop && (
                    <div className="text-center mt-6 text-base text-gray-600 font-medium">
                        Showing {Math.min(currentIndex + cardsPerView.desktop, sampleImages.length)} of {sampleImages.length} images
                    </div>
                )}
            </div>
        </div>
    );
};

export default ImageCarousel;
